module.exports = __webpack_public_path__ + "static/media/USDT.449d5755.jpeg";